import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, paymentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getCustomerGifts: ApiMethod<
  void,
  Server.CustomerGiftOutput[]
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Gifts_Client(undefined, paymentClient);

    const response = await client.gifts_get_V1();

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getReceivedGifts: ApiMethod<
  void,
  Server.CustomerGiftOutput[]
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Gifts_Client(undefined, paymentClient);

    const response = await client.gifts_received_get_V1();

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};
